<template>
	<div class="layout-main">
		<!--main title-->
		<div class="layout-main-wrap"
				 :class="{'layout-main-title-wrap-black': item.background}">
			<div id="main-title"
					 class="layout-main-title-wrap">
				{{headLine}}
			</div>
		</div>

		<div class="layout-maincontent">
			<div class="layout-maincontent-left">
				<div class="layout-image"
						 :class="{'safari-summary-text': isSafari}"
				>
					<div class="layout-image-wrap">
						<!--Event handler img-->
						<div class="image-caption">
							<img :class="{'android-image': isAndroid, 'safari-image': isSafari,'chrome-image': isChrome}"
									 :src="item.image_url" width="918" height="975"/>
						</div>
						<!--/.Event handler img-->

						<!--Caption to image-->
						<div class="layout-image-caption">
							<div class="layout-image-caption-wrap">
								<div class="layout-image-caption-text">
									<p class="text-horizontal" v-html="item.image_caption"/>
								</div>
							</div>
						</div>
						<!--/.Caption to image-->
					</div>

					<!--Image text summary-->
					<div class="layout-image-summary">
						<div class="layout-image-summary-wrap">
							<div class="layout-image-summary-text"
							 :class="{'layout-image-summary-text-bold': item.isLarge }">
								<p class="text-vertical" v-html="item.lead_sentence"/>
							</div>
						</div>
					</div>
					<!--/.Image text summary-->
				</div>

				<!-- Content text 540 -->
				<div class="layout-content-text"
						 :class="{'content-firefox': isFirefox}">
					<div class="layout-content-text-wrap"
							 :class="{'layout-content-text-wrap-input-bold': item.isLarge }">
						<p v-html="item.content"/>
					</div>
				</div>
			</div>
			<div class="layout-maincontent-right">
				<div class="layout-content-right-wrap-1">
					<div class="layout-subtitle-wrap-1">
						<p v-html="item.article_title" id="article_title"/>
					</div>
				</div>

				<div class="layout-content-right-wrap-2">
					<div class="layout-subtitle-wrap-2">
						<p class="layout-subtitle" v-html="item.sleeve_title" id="sleeve_title"/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import NewspaperMixin from '../../mixins/newspaper.mixin'
	import NewspaperModel from '../../models/newspaper.model'
	import { isSafari, isFirefox, isAndroid, isChrome } from 'mobile-device-detect'

	export default {
		name: 'FormReview',

		mixins: [NewspaperMixin('preview')],

		data () {
			return {
				isSafari,
				isFirefox,
				isAndroid,
				isChrome
			}
		},

		computed: {
			item () {
				return NewspaperModel.query().find(1)
			},

			headLine () {
				return this.item.headline && this.item.headline !== '<br>' ? this.item.headline : ''
			},

			isSafariBrowser () {
				return navigator.vendor && navigator.vendor.indexOf('Apple') > -1 &&
						navigator.userAgent &&
						navigator.userAgent.indexOf('CriOS') === -1 &&
						navigator.userAgent.indexOf('FxiOS') === -1
			},

			/**
			 * Detach is mobile
			 * @return boolean
			 */
			isMobileDevice () {
				return window.innerWidth < 1025
			}
		},

		methods: {
			/**
			 * set font size for export
			 */
			setFontSize () {

				return new Promise(resolve => {
					if (this.item.headline) {
						let inputLength = this.item.headline.length,
								scaleY = inputLength > 8 ? 1.9 : 1.5,
								containerWidth = document.getElementsByClassName('layout-main-wrap')[0].offsetWidth,
								fontSize = containerWidth / inputLength > 180 ? 180 : (containerWidth / inputLength) - 5

						const MainTitle = document.getElementById('main-title')

						MainTitle.style.cssText = `font-size: ${ fontSize }px; line-height: 1; transform: translate(0) scaleY( ${ scaleY })`
						const height = MainTitle.getBoundingClientRect().height

						resolve(height)
					}
				})

			},

			limitString (value, maxLength = 10) {
				return value.substr(0, maxLength)
			}
		},

		mounted () {
			this.setFontSize().then(value => {
				const wrap = document.getElementsByClassName('layout-main-wrap')[0]
				const mainTitle = document.getElementById('main-title')

				if (this.isMobileDevice) {
					wrap.style.height = value + 'px'
					mainTitle.style.top = -(wrap.offsetHeight - mainTitle.offsetHeight) / 4 - 30 + 'px'
				} else {
					wrap.style.height = value + 30 + 'px'
				}
			})
		}
	}
</script>

<style lang="scss" scoped>
	.layout-image {
		margin-bottom: 5px;
	}

	.safari-summary-text {
		.layout-image-summary {
			width: 115px !important;
		}

		.image-caption {
			width: 905px;
			overflow: hidden;

			img {
				width: 905px;
			}
		}
	}

	.content-firefox {
		width: 100.2%;
		float: right;
	}

	.chrome-image {
		@media #{$info-phone} {
			width: 895px !important;
		}
	}
</style>